import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
import { Check } from 'lucide-react';
interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  label?: string;
  onCheckedChange?: (checked: boolean) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({
  className,
  label,
  onCheckedChange,
  onChange,
  ...props
}, ref) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Call both handlers if they exist
    onChange?.(e);
    onCheckedChange?.(e.target.checked);
  };
  return <label className="flex items-center gap-2 cursor-pointer group" data-id="element-275">
        <div className="relative" data-id="element-276">
          <input type="checkbox" className="peer sr-only" ref={ref} onChange={handleChange} {...props} data-id="element-277" />
          <div className={cn('w-4 h-4 border-2 border-slate-300 rounded flex items-center justify-center transition-all', 'peer-checked:bg-primary-600 peer-checked:border-primary-600', 'peer-focus-visible:ring-2 peer-focus-visible:ring-primary-500 peer-focus-visible:ring-offset-2', 'group-hover:border-slate-400 peer-checked:group-hover:border-primary-700', className)} data-id="element-278">
            <Check className="w-3 h-3 text-white opacity-0 peer-checked:opacity-100 transition-opacity" data-id="element-279" />
          </div>
        </div>
        {label && <span className="text-sm text-slate-700 select-none" data-id="element-280">{label}</span>}
      </label>;
});
Checkbox.displayName = 'Checkbox';